import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";

export const Save_ledger_books = async (data) => {
  const { accountguid, voucherid, voucher_type, credit = 0, debit = 0 } = data || {};

  // Validation 
  if (!accountguid?.trim()) return { success: false, error: "Missing accountguid" };
  if (!voucherid?.trim()) return { success: false, error: "Missing voucherid" };
  if (!voucher_type?.trim()) return { success: false, error: "Missing voucher_type" };

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
  if (!guid) return { success: false, error: "Login expired. Please relogin." };
  if (!select_company_uid) return { success: false, error: "Contact service provider." };
const servicetablename = "accountingfinancedb";
  try {
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_books"
    );

    // Get last balance
    let balance = 0;

    const lastQuery = query(
      ledgerCollection,
      where("accountguid", "==", accountguid),
      orderBy("date_time", "desc"),
      limit(1)
    );

    const lastSnap = await getDocs(lastQuery);

    if (!lastSnap.empty) {
      const last = lastSnap.docs[0].data();
      const prev = last.balance || 0;

      // BLOCK NEGATIVE BALANCE
      if (debit > 0) {
        if (debit > prev) {
          return { success: false, error: "Insufficient balance. Debit not allowed." };
        }
        balance = prev - debit;
        // Update balance
      } else if (credit > 0) {
        balance = prev + credit;
      } else {
        balance = prev;
      }

    } else {
      // First entry
      if (debit > 0) {
        return { success: false, error: "Insufficient balance. Debit not allowed." };
      }
      if (credit > 0) balance = credit;
    }

    const uid = Randomcode(24);

    const docRef = doc(
      db,
      servicetablename,
      select_company_uid,
      "ledger_books",
      uid
    );

    const saveData = {
      ...data,
      ledgerid: uid,
      balance,
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(docRef, saveData);

    return { success: true, balance };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
